import { CartActions } from './../../constants/actionType'
import { store } from "../../../src/index"/**importing store for reducer values */

import * as checkoutAction from './checkout'
import * as buildProductAction from './buildProduct';

import { logOtherInfo, detailsInfo } from './../../service/logService'
import { apiUrl } from './../../constants/apiUrl'
import api from './../../service/apiService'
import { fetchAllMTM,fetchFiosData2YR,fetchFiosVoiceMTM,fetchFiosTVMTM ,fetchDataSubProductsOnClearCart} from './prefetch';
import { InHomeUtils } from './../../util/inhomeUtils';



export const cartToggle = (action, dispatch, visitId) => {
    logOtherInfo(detailsInfo('BuildProduct', visitId, 'cartToggle', "Inside cartToggle : action is : " + action));
    if(action==="existing"){
        dispatch({
            type: CartActions.toggleProfileCart,
            value: ""
        });
    }else{
        dispatch({ type: CartActions.toggleCart, value: "" });
    }
    
    if (action === "checkout") {
    let state = store.getState()
    let appState = state.app
    let buildProductState = state.buildProduct
        if(buildProductState.tv.FiosTvOneSelected && buildProductState.tv.vms1100Eligible ){
            /**post Soc call for vms1100 selection*/
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true ,isLoaderText:"checking out your cart"} });
            Promise.all([buildProductAction.fetchPostSoc(dispatch, appState.visitId, false)]).then(resp=>{
                checkoutAction.doValidateCart(appState.visitId, dispatch);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });

            }).catch(err=>{
                checkoutAction.doValidateCart(appState.visitId, dispatch);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            })
        }else{
        checkoutAction.doValidateCart(appState.visitId, dispatch, 0, 'postSoc');
        }
    }
};
export const offersToggle = (action, dispatch,visitId) => {
    logOtherInfo(detailsInfo('Cart',visitId,'offersToggle',"Inside offersToggle"));
    dispatch({ type: CartActions.toggleOffers, value: action });
};

export const showDueMonthlyDetails =(dispatch, action) => {
    dispatch({type: 'SHOW_DUE_MONTHLY_DETAILS', value:action})
}

export const toggleOneTimeCharges =(dispatch, action) => {
    dispatch({type: 'TOGGLE_ONE_TIME_CHARGES', value:action})
}

export const showSavingsDailog = (dispatch, action) => {
    dispatch({type: 'SHOW_SAVINGS_DAILOG', value: action})
}
export const splitBillTab = (action, dispatch) => {
    dispatch({ type: CartActions.splitBillTab, value: action });
}

export const toggleToolTip = (dispatch) => {
    dispatch({ type: 'TOGGLE_TOOLTIP', value: "" });
};

export const fiosSetupFee = (action, dispatch) => {
    dispatch({ type: 'FIOSSETUPFEE', value: action });
};
export const isShippingFee = (action, dispatch) => {
    dispatch({ type: 'ISSHIPPINGFEE', value: action });
}

export const mobileHelpReveal = (status, dispatch) => {
    dispatch({ type: 'MOBILE_HEADER', value: status })
};
const getClearCartRequest = () => {
    let request = { serviceType: 'ALL', productType: 'All' }
    return JSON.stringify(request)
};
export const clearcart = (visitId, dispatch, lqState, isPreselection = false, isPega = false, pegaModifyPlan = false) => {
    try{
    dispatch({
        type: 'LOADER_ACTIVE',
        value: { isLoaderActive: true, isLoaderText: "clearing cart", isLoaderImg: "loader" }
    });
    let url = ""; 
    let state = store.getState()
    let signIn = state.signIn
    let appState = state.app
    let buildProductState = state.buildProduct
    let profileCart = state.ecProfileCart

    if (buildProductState?.requiredErrBanner) {
        dispatch({type : 'SHOW_REQUIRED_ERR_BANNER', value : false})
    }
    
    url = apiUrl().clearCart + '/' + visitId;  
  let  request = getClearCartRequest();  
    api(url, 'POST', request).then(response =>{
        if (response.meta.code === 200 || response.meta.code === 200.0) { 
        dispatch({
            type:"CLEARCART",
            value:null
        });
        dispatch({
            type: "UPDATE_CLEARCART",
            value: null
        });
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } }); 
  
        let cart = response.data.cartTierPricing

        if(!isPega){
            buildProductAction.GetShoppingCartProducts(visitId, dispatch, signIn, buildProductState,cart, lqState, isPreselection);
        }
        let contract = InHomeUtils.isNotNull(profileCart) && InHomeUtils.isNotNull(profileCart.cartOrderDetail) && InHomeUtils.isNotNull(profileCart.cartOrderDetail.contract)
        && profileCart.cartOrderDetail.contract === 'MTM'
        ? profileCart.cartOrderDetail.contract : '2YR';
    buildProductState.contract.isAccordionDisabled = false;
    buildProductState.contract.isContractSwitched = true;
    buildProductState.contract.isAccordionOpenRequired = true;
    let contractState = buildProductState.contract;
    contractState.isContractSwitched = true;
    contractState.contractType = contract;
    buildProductAction.updateContractStatus(contractState, dispatch);
    let addlInfo = {
        zip: signIn.response.zipCode,
        state: signIn.response.state,
        tarCode: signIn.response.tarCode,

        selectedProductId: "",

        EquipmentState: null,
        isFCPflow: true,// signInState.response.userProfile.isFcpInProfile
        isAlaCarte: false
    };
    let isVecFlow = InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.ecLQResponse) && lqState.ecLQResponse.hoaFlag === "V" ? 'Y' : "N";
    let VecContractServices=InHomeUtils.isNotEmpty(signIn)&&InHomeUtils.isNotEmpty(signIn.response)&&InHomeUtils.isNotEmpty(signIn.response.hoaServiceType)?signIn.response.hoaServiceType:"";
        if(!pegaModifyPlan){
            if(VecContractServices.includes('DATA')&&isVecFlow==='Y'){
                fetchFiosData2YR(dispatch, appState.visitId, addlInfo)
                fetchFiosVoiceMTM(dispatch, appState.visitId, addlInfo)
                fetchFiosTVMTM(dispatch, appState.visitId, addlInfo)
            
            }else{
                fetchAllMTM(dispatch, appState.visitId, addlInfo)
                fetchDataSubProductsOnClearCart(dispatch, appState.visitId)
            }
        }    
    }
    if(!(signIn.response.visionCustomerId === '137442428' || signIn.response.visionCustomerId === '150395512' 
       || signIn.response.visionCustomerId === '550400420' || signIn.response.visionCustomerId === '159701634'
       || signIn.response.visionCustomerId === '259700008' || signIn.response.visionCustomerId === '359700012'
       || signIn.response.visionCustomerId === '459700001' || signIn.response.visionCustomerId === '659700145' || signIn.response.visionCustomerId === '259700147' || signIn.response.visionCustomerId === '557047080' || signIn.response.visionCustomerId === '257051757')){
    buildProductAction.toggleDataVoiceMultigig(dispatch)
    }else{
        buildProductAction.disableVoiceForSpecficVisionId(dispatch)   
    }
})
}catch(error){
    console.log(error)
}          
}; 
